export default __webpack_public_path__ + "static/media/male_circle.444f6777.svg";